var _mask, _path, _path2, _path3, _path4, _path5, _path6, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgButtonDeleteIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_17861_8433",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0V1.5H24V0V-1.5H8V0ZM32 8H30.5V24H32H33.5V8H32ZM24 32V30.5H8V32V33.5H24V32ZM0 24H1.5V8H0H-1.5V24H0ZM8 32V30.5C4.41015 30.5 1.5 27.5899 1.5 24H0H-1.5C-1.5 29.2467 2.75329 33.5 8 33.5V32ZM32 24H30.5C30.5 27.5899 27.5899 30.5 24 30.5V32V33.5C29.2467 33.5 33.5 29.2467 33.5 24H32ZM24 0V1.5C27.5899 1.5 30.5 4.41015 30.5 8H32H33.5C33.5 2.75329 29.2467 -1.5 24 -1.5V0ZM8 0V-1.5C2.75329 -1.5 -1.5 2.75329 -1.5 8H0H1.5C1.5 4.41015 4.41015 1.5 8 1.5V0Z",
    fill: "#F93336",
    mask: "url(#path-1-inside-1_17861_8433)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17861_8433",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9526 23.5031H13.0477C12.0676 23.5031 11.2526 22.7485 11.1775 21.7712L10.3728 11.3105H21.6275L20.8228 21.7712C20.7476 22.7485 19.9327 23.5031 18.9526 23.5031V23.5031Z",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6695 11.3105H9.33057",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6554 8.49689H18.3449C18.8629 8.49689 19.2828 8.9168 19.2828 9.43478V11.3106H12.7175V9.43478C12.7175 8.9168 13.1374 8.49689 13.6554 8.49689Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6414 15.0621V19.7516",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3587 15.0621V19.7516",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17861_8433)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 20,
    height: 20,
    fill: "#F93336"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgButtonDeleteIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ButtonDeleteIcon.fffa10f2.svg";
export { ForwardRef as ReactComponent };